<div *ngIf="dashboardURL">
    <div #dashboardContainer class="dashboard-container"></div>
  </div>
  <div *ngIf="!dashboardURL">
    <p>Error: No dashboard URL provided.</p>
  </div>